import React from 'react';
import {
  buildDefaultTargetDir,
  loadDefaultImage as loadDefaultImageUtil,
  deleteDefaultContents as deleteDefaultContentsUtil,
  uploadDefaultImageFile,
  parseDefaultImgLink,
} from "./ContentLibraryUtils";

import {Button,Box, TextField, LinearProgress, Chip} from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContentLibrary from "./ContentLibrary";
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/Warning';
import ScreenSelection from './ScreenSelection';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import AddScreenIcon from '@mui/icons-material/AddToQueue';
import Dropzone from "react-dropzone";
import * as ETVConstants from '../ETVConstants';
import TimeDateSettings from '../tools/TimeDateSettings';
import { ClockIcon } from '@mui/x-date-pickers';
import { Delete, Flag, Image, Tv } from '@mui/icons-material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import MUISchedulePicker from '../tools/MuiSchedulePicker';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVPopup from '../tools/ETVPopup';
import ETVTable from '../tools/ETVTable';

class PlaylistChannel extends React.Component {
	playlistStatusGeneration = 0;
	playlistLoadGeneration = 0;

	constructor(props) {
      	super(props);
      	this.externalUpdatedF = this.externalUpdatedF.bind(this);
      	this.closeSettings = this.closeSettings.bind(this);
		this.closeInfoMessage = this.closeInfoMessage.bind(this);
    }

    state = {
      	items:[],
      	isLoaded: false,
		isLoading: false,
      	library_element: undefined,
		show_all_contents: false,
		default_img_link:undefined,
		uploading_default_img:false,
		can_edit:true,
		schedule:{},
		stream_url:'',
		isValidStreamUrl:true,
		tv_changed:false,
		playlist_sync_status:null,
		synchronized:false,
		synchronizedMixed:false,
		savingSynchronization:false,
		synchronizationError:'',
    }

	componentDidUpdate(prevProps, prevState) {
      if(!this.state.isLoaded && !this.state.isLoading) {
        this.loadPlaylist();
      }
      if(prevProps.device_id!==this.props.device_id || prevProps.group_id!==this.props.group_id || prevProps.channel!==this.props.channel) {
        this.loadPlaylist();
      }
	  if(prevProps.device_id!==this.props.device_id || prevProps.group_id!==this.props.group_id || prevProps.channel!==this.props.channel) {
		this.playlistStatusGeneration += 1;
		this.setState({playlist_sync_status:null});
		this.loadPlaylistSyncStatus();
	  }
	}

    componentDidMount() {
      this.loadPlaylist();
	  this.loadPlaylistSyncStatus();
	  this.playlistStatusTimer = window.setInterval(() => this.loadPlaylistSyncStatus(), 15000);
    }

	componentWillUnmount() {
		this.playlistLoadGeneration += 1;
		this.playlistStatusGeneration += 1;
		if(this.playlistStatusTimer) window.clearInterval(this.playlistStatusTimer);
	}

	loadPlaylistSyncStatus() {
		const statusGeneration = this.playlistStatusGeneration;
		const accessToken = localStorage.getItem("etv.access_token");
		const reqUserID = localStorage.getItem("etv.user_id");
		let url = ETVConstants.getServerBase()+"/playlist?action=get_sync_status&channel="+this.props.channel;
		if(this.props.group_id>=0) {
			url += "&group_id="+encodeURIComponent(this.props.group_id);
		}else if(this.props.device_id) {
			url += "&device_id="+encodeURIComponent(this.props.device_id);
		}else{
			return;
		}
		fetch(url,{headers:{'user_id':reqUserID,'access_token':accessToken},cache:'no-store'})
			.then(res => res.json())
			.then(result => {
				if(statusGeneration===this.playlistStatusGeneration && result && result.result!==false) {
					this.setState({playlist_sync_status:result});
				}
			})
			.catch(() => {});
	}

	playlistChanged() {
		this.playlistStatusGeneration += 1;
		const previousStatus = this.state.playlist_sync_status;
		let pendingStatus = previousStatus;
		if(previousStatus?.mode==='group') {
			pendingStatus = {...previousStatus, downloaded:0, active:0};
		}else if(previousStatus?.supported) {
			pendingStatus = {
				...previousStatus,
				downloaded:false,
				active:false,
				downloaded_at:null,
				active_at:null,
			};
		}
		this.setState({isLoaded:false, playlist_sync_status:pendingStatus});
		this.loadPlaylistSyncStatus();
	}

	getPlaylistSyncStatus() {
		const status = this.state.playlist_sync_status;
		if(!status) return null;
		if(status.mode==='group') {
			const total = Number(status.total || 0);
			if(total===0) return <Chip size="small" variant="outlined" label={ETVConstants.trans("playlist_status_unavailable")}/>;
			const active = Number(status.active || 0);
			const downloaded = Number(status.downloaded || 0);
			const isActive = active===total;
			const isDownloaded = downloaded===total;
			const label = isActive
				? `${ETVConstants.trans("playlist_active")}: ${active}/${total}`
				: isDownloaded
					? `${ETVConstants.trans("playlist_downloaded")}: ${downloaded}/${total}`
					: `${ETVConstants.trans("playlist_pending_download")}: ${downloaded}/${total}`;
			return <Tooltip title={`${status.supported || 0}/${total} ${ETVConstants.trans("screens_reporting")}`}>
				<Chip
					size="small"
					sx={{ml:'auto'}}
					icon={isActive?<PlayCircleOutlineIcon/>:<CloudDownloadOutlinedIcon/>}
					color={isActive?'success':(isDownloaded?'warning':'error')}
					label={label}
				/>
			</Tooltip>;
		}
		if(!status.supported) {
			return <Chip size="small" sx={{ml:'auto'}} variant="outlined" label={ETVConstants.trans("playlist_status_unavailable")}/>;
		}
		const isActive = Boolean(status.active);
		const isDownloaded = Boolean(status.downloaded);
		const label = isActive
			? ETVConstants.trans("playlist_active")
			: isDownloaded
				? ETVConstants.trans("playlist_downloaded")
				: ETVConstants.trans("playlist_pending_download");
		const reportedAt = isActive ? status.active_at : status.downloaded_at;
		const title = reportedAt ? `${ETVConstants.trans("last_reported")}: ${reportedAt}` : '';
		return <Tooltip title={title}>
			<Chip
				size="small"
				sx={{ml:'auto'}}
				icon={isActive?<PlayCircleOutlineIcon/>:<CloudDownloadOutlinedIcon/>}
				color={isActive?'success':(isDownloaded?'warning':'error')}
				label={label}
			/>
		</Tooltip>;
	}

	loadPlaylist() {
		const generation = ++this.playlistLoadGeneration;
		this.setState({isLoading:true});
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/playlist?device_id="+this.props.device_id+"&channel="+this.props.channel+"&user_id="+this.props.user_id;
		if(this.props.group_id>=0) {
			url = ETVConstants.getServerBase()+"/playlist?group_id="+this.props.group_id+"&channel="+this.props.channel+"&user_id="+this.props.user_id;
		}
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
			(result) => {
				if(generation!==this.playlistLoadGeneration) return;
				this.checkTV(result.list);
				this.setState({items: this.filterOutTV(result.list), isLoaded: true, isLoading:false, tv_changed:false,
					synchronized:result.synchronized===true, synchronizedMixed:result.synchronizedMixed===true,
					synchronizationError:result.syncTimingError || ''});
			},
			(error) => {
				if(generation!==this.playlistLoadGeneration) return;
				this.setState({
				items:[],
				isLoaded: false,
				isLoading:false,
				error
				});
			}
			)
	}

	checkTV( list) {
		//console.log(JSON.stringify(list));
		var filtered = [];
		for(var i=0; i<list.length; i++) {
			//console.log("check filename="+list[i].library_element.filename);
			if(list[i].library_element.filename==="tv.tv") {
				let contentID = list[i].library_element.content_id;
				let streamURL = list[i].library_element.url;
				var scheduleObj = list[i].library_element.schedule;
				//console.log("contentID="+contentID+" streamURL="+streamURL+" schedule="+JSON.stringify(scheduleObj));
				this.setState({tv_content_id:contentID, stream_url:streamURL, schedule:scheduleObj, isValidStreamUrl:true});
				return;
			}
		}
		//no tv found
		this.setState({tv_content_id:undefined, stream_url:'', schedule:{}, isValidStreamUrl:true});
	}

	//filtering the items on whether they are currently active
	filterItems( list) {
		if(this.state.show_all_contents) return list;
		// filter out not active items
		var res = [];
		for(var i=0; i<list.length; i++) {
			if(this.isCurrentlyShown(list[i])) {
				res.push(list[i]);
			}
		}
		return res;
	}

	filterOutTV( list) {
		var res = [];
		for(var i=0; i<list.length; i++) {
			if(list[i].library_element.filename!=='tv.tv') {
				res.push(list[i]);
			}
		}
		return res;
	}	

	// currently shown
	isCurrentlyShown( elem) {
		var element = elem.library_element;
		var days = element.weekdays;
		var validWeekday = this.checkValidWeekdayToday(days);
		if(!validWeekday) return false;
		if(!this.checkValidDate(element.from_date,element.to_date)) return false;
		if(!this.checkValidTime(element.from_time,element.to_time)) return false;
		if(!element.active) return false;
		return true;
	}

	removeFromPlaylist(playlistId) {
		let url =
			ETVConstants.getServerBase() +
			`/playlist?action=remove&channel=${this.props.channel}` +
			`&user_id=${this.props.user_id}` +
			`&playlist_id=${encodeURIComponent(String(playlistId))}` +
			`&_ts=${Date.now()}`;

		if (this.props.group_id >= 0) {
			url += `&group_id=${this.props.group_id}`;
		} else {
			url += `&device_id=${encodeURIComponent(this.props.device_id)}`;
		}

		this.updatePlaylist(url);
	}

	moveDown(playlistId) {
		let url =
			ETVConstants.getServerBase() +
			`/playlist?action=move_down&channel=${this.props.channel}` +
			`&user_id=${this.props.user_id}` +
			`&playlist_id=${encodeURIComponent(String(playlistId))}` +
			`&_ts=${Date.now()}`;

		if (this.props.group_id >= 0) {
			url += `&group_id=${this.props.group_id}`;
		} else {
			url += `&device_id=${encodeURIComponent(this.props.device_id)}`;
		}

		this.updatePlaylist(url);
	}

	moveUp(playlistId) {
		let url =
			ETVConstants.getServerBase() +
			`/playlist?action=move_up&channel=${this.props.channel}` +
			`&user_id=${this.props.user_id}` +
			`&playlist_id=${encodeURIComponent(String(playlistId))}` +
			`&_ts=${Date.now()}`;

		if (this.props.group_id >= 0) {
			url += `&group_id=${this.props.group_id}`;
		} else {
			url += `&device_id=${encodeURIComponent(this.props.device_id)}`;
		}

		this.updatePlaylist(url);
	}

    getLowestRank() {
      if(this.state.items.length>0) {
        var lowest = this.state.items[0].rank;
        for(var i=1; i<this.state.items.length; i++) {
          var elemRank = this.state.items[i].rank;
          if(elemRank<lowest) {
            lowest = elemRank;
          }
        }
        return lowest;
      }else{
        return -1;
      }
    }

    getHighestRank() {
      if(this.state.items.length>0) {
        var highest = this.state.items[0].rank;
        for(var i=1; i<this.state.items.length; i++) {
          var elemRank = this.state.items[i].rank;
          if(elemRank>highest) {
            highest = elemRank;
          }
        }
        return highest;
      }else{
        return -1;
      }
    }

    updatePlaylist( url) {
		//console.log("playlist url to backend="+url);
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then( res => res.json() )
			.then(
				(result) => {
					this.playlistChanged();
				},
				(error) => {this.setState({isLoaded:false});}
			)
	}

    addFromLibrary(marketplace) {
      if(marketplace) {
        this.showWindow('add_from_marketplace',true);
      }else{
        this.showWindow('add_from_library',true);
      }
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

    closeLibrary() {
      this.showWindow('add_from_library',false);
      this.setState({isLoaded:false});
    }

    getIds() {
      var res = [];
      for(var i=0; i<this.state.items.length; i++) {
        res.push(this.state.items[i].library_element.content_id);
      }
      return res;
    }

    getContentElement( id) {
        //console.log("xxxxxx getContentElement====>items="+this.state.items.length+" search for contentID="+id);
        for(var i=0; i<this.state.items.length; i++) {
            //console.log("xxxx===> checking "+this.state.items[i].library_element.content_id);
            if(this.state.items[i].library_element.content_id===id) {
              return this.state.items[i].library_element;
            }
        }
    }

    showScreens( contentID) {
      var elem = this.getContentElement(contentID);
      this.setState({library_element:elem});
      this.showWindow('show_screens_div',true);
    }

    closeScreens() {
        this.showWindow('show_screens_div',false);
        this.setState({isLoaded:false});
    }

    showTiming( canEdit, contentID) {
      var elem = this.getContentElement(contentID);
      this.setState({can_edit: canEdit, library_element:elem, window:'time_settings_div'});
    }

    closeSettings() {
        this.showWindow('time_settings_div',false);
        this.setState({isLoaded:false});
    }

    showFilename( element) {
      	var name = element.filename.substring(element.filename.indexOf("_")+1, element.filename.length);
		var color = element.active?'#000000':'#C0C0C0';
		var url = element.url;
		return <Typography variant='body2' title={name} sx={{color,maxWidth:360,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}><a href={ETVConstants.ON_PREMISE_VERSION?ETVConstants.makeContentURLRelative(url):url} style={{color,display:'block',overflow:'hidden',textOverflow:'ellipsis'}}>{name}{this.showContextRestrictions(element)}{this.insertOutOfTimeWarning(element)}</a></Typography>
    }

	showContextRestrictions(element) {
		if (!element || !element.restrictions) {
			return <span/>;
		}
		const hasRestrictions = Object.keys(element.restrictions).length > 0;
		if(!hasRestrictions) return <span/>;
		const tooltipText = Object.entries(element.restrictions)
			.map(([key, value]) => {
				if (value && Array.isArray(value.values)) {
					return `${key}: ${value.values.join(', ')}`;
				}
				return `${key}: -`; // fallback if `values` is missing
			})
			.join(' | ');
		return (<Tooltip title={tooltipText}>
			<Flag style={{margin:0, color:'#640bf1ff'}}/>
		</Tooltip>)
	}

	insertOutOfTimeWarning( element) {
		// check weekday
		var days = element.weekdays;
		if(!this.checkValidWeekdayToday(days)) {
			return (
				<Tooltip title={ETVConstants.trans("not_played_on_current_weekday")}>
					<WarningAmberIcon style={{margin:2, color:'#ffcc00'}}/>
				</Tooltip>
			)
		}
		if(!this.checkValidDate(element.from_date,element.to_date)) {
			return (
				<Tooltip title={ETVConstants.trans("out_of_date")}>
					<WarningAmberIcon style={{margin:2, color:'#ffcc00'}}/>
				</Tooltip>
			)
		}
		if(!this.checkValidTime(element.from_time,element.to_time)) {
			return (
				<Tooltip title={ETVConstants.trans("out_of_time")}>
					<WarningAmberIcon style={{margin:2, color:'#ffcc00'}}/>
				</Tooltip>
			)
		}
		return "";
	}

	checkValidTime(fromTime, toTime) {
		if (!fromTime && !toTime) {
			return true; // No restrictions
		}
		var nowTime = this.checkTimeFormat(this.createNowTime());
		if (fromTime) {
			fromTime = this.checkTimeFormat(fromTime);
		}
		if (toTime) {
			toTime = this.checkTimeFormat(toTime);
		}

		if (fromTime && toTime) {
			// Equal values represent a full day (00:00-00:00 is the UI's clear value).
			if (fromTime === toTime) return true;
			if (fromTime < toTime) {
				return nowTime >= fromTime && nowTime < toTime;
			}
			// An earlier end time means that the range continues across midnight.
			return nowTime >= fromTime || nowTime < toTime;
		}

		if (fromTime) return nowTime >= fromTime;
		if (toTime) return nowTime < toTime;
		return true;
	}


	checkTimeFormat(t) {
		var h = t.substring(0,t.indexOf(":"));
		var m = t.substring(t.indexOf(":")+1);
		if(h.length===1) h="0"+h;
		if(m.length===1) m="0"+m;
		return h+":"+m;
	}

	createNowTime() {
		var today = new Date();
		return today.getHours()+":"+(today.getMinutes()<10?"0"+today.getMinutes():today.getMinutes());
	}

	checkValidDate(fromDate,toDate) {
		if(!fromDate && !toDate) return true;
		var todayDate = this.createTodayDate();
		if(fromDate) {
			var fromD = new Date(fromDate);
			fromD.setHours(0,0,0);
			if(fromD>todayDate) {
				return false;
			}
		}
		if(toDate) {
			var toD = new Date(toDate);
			toD.setHours(0,0,0);
			if(toD<todayDate) return false;
		}
		return true;
	}

	createTodayDate() {
		var today = new Date();
		today.setHours(0,0,0,0);
		return today;
	}

	checkValidWeekdayToday(weekdays) {
		var d = new Date();
		var curD = d.getDay();
		if( (curD===0) && weekdays.includes("sunday")) return true;
		if( (curD===1) && weekdays.includes("monday")) return true;
		if( (curD===2) && weekdays.includes("tuesday")) return true;
		if( (curD===3) && weekdays.includes("wednesday")) return true;
		if( (curD===4) && weekdays.includes("thursday")) return true;
		if( (curD===5) && weekdays.includes("friday")) return true;
		if( (curD===6) && weekdays.includes("saturday")) return true;
		return false;
	}

	showPlayingTime( element) {
		var color = element.active?'#000000':'#C0C0C0';
		return <Typography variant='body2' style={{color:color}}>{this.isMovie(element)?"":element.showing_time}</Typography>
	}

	getSettingsButton( element) {
		var canEdit = this.canEdit(element.owner_id);
		return(
			<IconButton size='small' disabled={!element.active} variant='contained' color='primary' onClick={()=>this.showTiming(canEdit, element.content_id)}>
					{canEdit?<ClockIcon/>:<VisibilityIcon/>}
			</IconButton>
		)
	}

	getScreensButton( element) {
		return (
			<IconButton 
				disabled={!element.active }
				size='small'
				variant='contained'
				color='primary'
				onClick={()=>this.showScreens(element.content_id)}>
				<AddScreenIcon/>
			</IconButton>
		)
	}

	getDeleteIcon(row) {
		const pid = row?.playlist_id;
		return (
			<Tooltip title={ETVConstants.trans("remove_from_playlist")}>
			<IconButton
				disabled={!pid}
				size="small"
				variant="contained"
				color="error"
				onClick={() => this.removeFromPlaylist(pid)}
			>
				<DeleteIcon/>
			</IconButton>
			</Tooltip>
		);
	}

	setActiveF( contentID, isActive) {
		var url = ETVConstants.getServerBase()+"/content_library?action=set_active&content_id="+contentID+"&active="+isActive;
		this.updateContentRegistry(url);
	}

	updateContentRegistry( url) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then( res => res.json() )
			.then(
					(result) => {
						this.playlistChanged();
					},
					(error) => {
					}
				)
	}

    isMovie( element) {
      if (element.filename.toLowerCase().endsWith('.mp4')) return true;
      if (element.filename.toLowerCase().endsWith('.mpeg')) return true;
      if (element.filename.toLowerCase().endsWith('.mp3')) return true;
      if (element.filename.toLowerCase().endsWith('.mov')) return true;
      if (element.filename.toLowerCase().endsWith('.avi')) return true;
      return false;
    }

	getActiveIcon( element) {
		var canEdit = this.canEdit(element.owner_id);
		var isActive = element.active;
		var id = element.content_id;
		//console.log("xx getActiveIcon, id="+id+" isActive="+isActive+" canEdit="+canEdit);
		if(!isActive) {
			return(
						<Tooltip title={ETVConstants.trans("set_active")}>
								<span>
								<IconButton size='small' disabled={!canEdit} aria-label="activate" color={(canEdit?"error":"#C0C0C0")} onClick={() => this.setActiveF(id,!isActive)}><BlockIcon/></IconButton>
								</span>
						</Tooltip>
					)
		}else{
			return(
					<Tooltip title={ETVConstants.trans("set_inactive")}>
							<span>
							<IconButton size='small' disabled={!canEdit} aria-label="active" color={(canEdit?"success":"#C0C0C0")} onClick={() => this.setActiveF(id,!isActive)}><CheckIcon/></IconButton>
							</span>
					</Tooltip>
			)
		}
	}

	getRankIconUp(index, row) {
		if (index === 0) return <span/>;
		const pid = row?.playlist_id;
		return (
			<span>
			<IconButton
				size="small"
				disabled={!pid}
				onClick={() => this.moveUp(pid)}
				style={{ color: "green" }}
			>
				<KeyboardArrowUpIcon/>
			</IconButton>
			</span>
		);
	}

	getRankIconDown(index, row) {
		if (index === this.state.items.length - 1) return <span/>;
		const pid = row?.playlist_id;
		return (
			<span>
			<IconButton
				size="small"
				disabled={!pid}
				onClick={() => this.moveDown(pid)}
				style={{ color: "red" }}
			>
				<KeyboardArrowDownIcon/>
			</IconButton>
			</span>
		);
	}

	externalUpdatedF() {
		this.playlistChanged();
	}

	getActiveSelection() {
		var switchActive = this.state.items && this.state.items.length>0;
		return <FormControlLabel control={<Switch color='primary' disabled={!switchActive} checked={this.state.show_all_contents} onClick={()=>{this.switchActiveContents()}} />} label={this.state.show_all_contents?ETVConstants.trans("all_contents"):ETVConstants.trans("active_contents")} />
	}

	async setSynchronizedPlaylist(enabled) {
		const generation = this.playlistStatusGeneration;
		this.setState({savingSynchronization:true, synchronizationError:''});
		const params = new URLSearchParams({action:'set_synchronized', channel:String(this.props.channel), synchronized:String(enabled)});
		if(this.props.group_id>=0) params.set('group_id', this.props.group_id);
		else params.set('device_id', this.props.device_id);
		try {
			const response = await fetch(ETVConstants.getServerBase()+'/playlist', {
				method:'POST',
				headers:{'Content-Type':'application/x-www-form-urlencoded',
					'user_id':localStorage.getItem('etv.user_id'), 'access_token':localStorage.getItem('etv.access_token')},
				body:params.toString()
			});
			if(!response.ok) throw new Error(ETVConstants.trans('synchronized_playlist_save_failed'));
			const result = await response.json();
			if(result.result!==true || result.error) throw new Error(result.reason || result.message || result.error || ETVConstants.trans('synchronized_playlist_save_failed'));
			if(generation!==this.playlistStatusGeneration) return;
			this.setState({synchronized:enabled, synchronizedMixed:false});
			this.playlistChanged();
		} catch(error) {
			if(generation===this.playlistStatusGeneration) this.setState({synchronizationError:error.message});
		} finally {
			this.setState({savingSynchronization:false});
		}
	}

	getSynchronizationSelection() {
		return <span>
			<Tooltip title={ETVConstants.trans('synchronized_playlist_tooltip')}>
				<FormControlLabel control={<Switch color="primary"
					disabled={!this.state.isLoaded || this.state.isLoading || this.state.savingSynchronization}
					checked={this.state.synchronized}
					onChange={(event)=>this.setSynchronizedPlaylist(event.target.checked)}/>}
					label={ETVConstants.trans('synchronized_playlist')}/>
			</Tooltip>
			{this.state.synchronizedMixed && <Typography component="span" variant="caption">{ETVConstants.trans('synchronized_playlist_mixed')}</Typography>}
			{this.state.synchronizationError && <Typography role="alert" color="error" variant="body2">{this.state.synchronizationError}</Typography>}
		</span>;
	}

	switchActiveContents() {
		this.setState({show_all_contents:!this.state.show_all_contents});
	}

	canEdit( ownerID) {
		var userID = this.props.user_id;
		var isChild = this.props.children.includes(ownerID);
		return (userID===ownerID) || isChild;
	}

	showAddDefaultImage() {
	this.showWindow("add_default_image", true);
	this.loadDefaultImage();
	}

	loadDefaultImage() {
		loadDefaultImageUtil(
			ETVConstants,
			{ deviceId: this.props.device_id, channel: this.props.channel },
			(jsonObj) => this.setState({ default_img_link: parseDefaultImgLink(jsonObj) })
		);
	}

	deleteDefaultContents() {
		deleteDefaultContentsUtil(
			ETVConstants,
			{ deviceId: this.props.device_id, channel: this.props.channel },
			(jsonObj) => this.setState({ default_img_link: parseDefaultImgLink(jsonObj) })
		);
	}

	onDrop = async (files) => {
		if (!files || files.length === 0) return;

		const file = files[0];
		const targetDir = buildDefaultTargetDir(this.props.device_id, this.props.channel);

		this.setState({ uploading_default_img: true });

		await uploadDefaultImageFile({
			ETVConstants,
			file,
			targetDir,
			// Optional: if you still want to drive a progress bar, map loaded/total to pct
			// onProgress: (loaded, total) => this.updateProgress(total, loaded),
			onDone: () => {
			this.setState({ uploading_default_img: false });
			this.loadDefaultImage();
			},
			onError: () => {
			this.setState({ uploading_default_img: false });
			},
		});
	};

	rxDefaultImage(jsonObj) {
		//console.log("obj="+JSON.stringify(jsonObj));
		if(!jsonObj) {
			this.setState({default_img_link:undefined});
			return;
		}
		var list = jsonObj.default_contents;
		if(!list || list.length==0) {
			this.setState({default_img_link:undefined});
			return;
		}
		var link = list[0].link;
		if(!link) {
			this.setState({default_img_link:undefined});
			return;
		}
		this.setState({default_img_link:link});
	}

	showAddTV() {
		this.setState({window:'add_tv_div'});
	}

	setSaveTV() {
		this.showInfoMessage("save","saving",true);
		//console.log("saving schedule: "+this.state.stream_url+" schedule="+JSON.stringify(this.state.schedule));
    	const accessToken = localStorage.getItem('etv.access_token');
    	const reqUserID = localStorage.getItem('etv.user_id');
		var url = ETVConstants.getServerBase()+"/tv_mgmt?action=add_tv&channel="+this.props.channel+"&user_id="+reqUserID;
		if(this.props.group_id>=0) {
			url += "&group_id="+this.props.group_id;
		}else{
			url += "&device_id="+this.props.device_id;
		}
		url += "&tv_url="+encodeURIComponent(this.state.stream_url);
		url += "&schedule="+encodeURIComponent(JSON.stringify(this.state.schedule));
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
				(result) => {
					//console.log("tv save result="+JSON.stringify(result));
					if(result.result) {
						this.playlistChanged();
						this.showSuccessMessage("success","tv settings stored",false);
					}else{
						if(result.reason==='app_version_mismatch') {
							this.showErrorMessage(ETVConstants.trans(result.reason),"min APK"+result.min_version);
						}else{
							this.showErrorMessage("error",ETVConstants.trans(result.reason));
						}
					}
				}
			)
	}

	removeTV() {
		this.showInfoMessage("delete","removing",true);
    	const accessToken = localStorage.getItem('etv.access_token');
    	const reqUserID = localStorage.getItem('etv.user_id');
		var url = ETVConstants.getServerBase()+"/tv_mgmt?action=remove_tv&content_id="+this.state.tv_content_id;
		//console.log("removeTV_url="+url);
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
				(result) => {
					this.playlistChanged();
					this.showSuccessMessage("success","tv removed",false);
					//console.log("result="+JSON.stringify(result));
				}
			)
	}	

	updateSchedule( sched) {
		this.setState({schedule:sched});
	}

	showInfoMessage(title,msg,isSpinning) {
		this.setState({window:'message_div',info_type:'info',info_title:title,info_message:msg,spinning:isSpinning});
	}

  	showSuccessMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'success',info_title:title,info_message:msg,spinning:false});
	}

	showErrorMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
	}

  	closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined, spinning:false, isLoaded:false});
  	}	

	getRankButtons(index, row, listLength) {
		const pid = row?.playlist_id;
		const isFirst = index === 0;
		const isLast = index === listLength - 1;

		return (
			<Box sx={{ display: "inline-flex", alignItems: "center" }}>
			<Tooltip title={ETVConstants.trans("move_up")}>
				<span>
				<IconButton
					size="small"
					disabled={!pid || isFirst}
					onClick={() => this.moveUp(pid)}
					sx={{
					border: "1px solid",
					borderColor: "divider",
					borderRadius: 1,
					mr: 0.5,
					}}
				>
					<KeyboardArrowUpIcon fontSize="small" />
				</IconButton>
				</span>
			</Tooltip>

			<Tooltip title={ETVConstants.trans("move_down")}>
				<span>
				<IconButton
					size="small"
					disabled={!pid || isLast}
					onClick={() => this.moveDown(pid)}
					sx={{
					border: "1px solid",
					borderColor: "divider",
					borderRadius: 1,
					}}
				>
					<KeyboardArrowDownIcon fontSize="small" />
				</IconButton>
				</span>
			</Tooltip>
			</Box>
		);
	}

    render() {
		var excludedIDs = this.getIds();
		var filtered = this.filterItems(this.state.items);
		const playlistColumns = [
			{title:'',field:'rank',width:92,render:(row)=>this.getRankButtons(filtered.indexOf(row),row,filtered.length)},
			{title:ETVConstants.trans("filename"),field:'library_element.filename',render:(row)=>this.showFilename(row.library_element)},
			{title:ETVConstants.trans("showing_time_s"),field:'playing_time',width:100,render:(row)=>this.showPlayingTime(row.library_element)},
			{title:ETVConstants.trans("settings"),field:'settings',width:75,render:(row)=>this.getSettingsButton(row.library_element)},
			{title:ETVConstants.trans("screens"),field:'screens',width:75,render:(row)=>this.getScreensButton(row.library_element)},
			{title:ETVConstants.trans("active"),field:'active',width:70,render:(row)=>this.getActiveIcon(row.library_element)},
			{title:ETVConstants.trans("remove"),field:'remove',width:75,render:(row)=>this.getDeleteIcon(row)},
		];
	    return(
			<Box>
				{this.state.isLoading?<LinearProgress/>:<span/>}
	        	<Box sx={{pt:1}}>
						<Box sx={{display:'flex',alignItems:'center',gap:1,flexWrap:'wrap',mb:1.5}}>
							<Typography variant="h6" fontWeight={700} sx={{mr:1}}>{ETVConstants.trans("channel")}&nbsp;{this.props.channel}</Typography>
							<Button size='small' variant="contained" color="primary" startIcon={<Image/>} onClick={() => this.addFromLibrary(false)}>{ETVConstants.trans("add_content")}</Button>
											{(this.props.is_device_owner && this.props.group_id==-1 && this.props.sw_version>=91?<Button size='small' variant="contained" color="primary" startIcon={<Image/>} onClick={() => this.showAddDefaultImage()}>{ETVConstants.trans("default_image")}</Button>:<span/>)}&nbsp;
							{(this.props.marketaccess && !ETVConstants.ON_PREMISE_VERSION)?<Button size='small' variant="contained" startIcon={<StorefrontIcon/>} color="primary" onClick={() => this.addFromLibrary(true)}>{ETVConstants.trans("marketplace")}</Button>:<span/>} <Button variant='contained' size='small' color='primary' startIcon={<Tv/>} onClick={()=>{this.showAddTV()}}>{ETVConstants.trans("television")}</Button>
							{this.getPlaylistSyncStatus()}
						</Box>
						<Box sx={{mb:1.5}}>{this.getActiveSelection()}{this.getSynchronizationSelection()}</Box>
						<ETVTable data={filtered} columns={playlistColumns} title="" pageSize={10} search embedded options={{padding:'dense',tableLayout:'fixed'}} />
		   		</Box>

				<ETVPopup
					open={this.state.window==='add_from_library'}
					onClose={()=>{this.closeLibrary()}}
					width="wide"
					icon={<Image/>}
					title={ETVConstants.trans("add_from_library")}
					bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.closeLibrary()}/>}
				>
						{this.state.window==='add_from_library'?<ContentLibrary visible={this.state.window==='add_from_library'} children={this.props.children} marketplace={false} user_id={this.props.user_id} channel={this.props.channel} group_id={this.props.group_id} device_id={this.props.device_id} excluded_ids={excludedIDs} addedToChannelF={this.externalUpdatedF} />:<span/>}
				</ETVPopup>

				<ETVMessagePopup type={this.state.spinning?'progress':(this.state.info_type || 'info')} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message} />

				<ETVPopup
					open={this.state.window === 'add_tv_div'}
					width="standard"
					onClose={()=>this.setState({window:''})}
					icon={<Tv/>}
					title={ETVConstants.trans("television")}
					description={ETVConstants.trans("tv_desc")}
					bottomActions={<>
						<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.setState({window:''})}/>
						<Button disabled={!this.state.tv_content_id} onClick={()=>this.removeTV()} startIcon={<Delete/>} color="error" variant='contained'>{ETVConstants.trans("remove")}</Button>
						<ETVActionButton action="save" onClick={()=>this.setSaveTV()} disabled={!this.state.isValidStreamUrl || !this.state.tv_changed || !this.state.schedule || Object.keys(this.state.schedule).length===0}/>
					</>}
				>
					<Chip label="Apk97+" color="primary" variant="outlined" size="small" />
						<TextField
							fullWidth
							variant="outlined"
							label={ETVConstants.trans("streaming_url")}
							placeholder="e.g. rtsp://192.168.1.30:554/1"
							margin="normal"
							value={this.state.stream_url || ""}
							onChange={(e) => {
							const url = e.target.value.trim();
							let valid = false;
							try {
								// Will throw if invalid
								new URL(url);
								valid = true;
							} catch (_) {
								valid = false;
							}
							this.setState({ stream_url: url, isValidStreamUrl: valid, tv_changed:true });
							}}
							error={Boolean(this.state.stream_url) && !this.state.isValidStreamUrl}
							helperText={
								Boolean(this.state.stream_url) && !this.state.isValidStreamUrl
								? ETVConstants.trans("invalid_url")
								: " "
							}
						/>
						<MUISchedulePicker value={this.state.schedule} onSchedule={(updated) => this.setState({ schedule: updated, tv_changed:true })}						/>
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='add_default_image'}
					width="small"
					onClose={()=>this.showWindow('',false)}
					icon={<Image/>}
					title={ETVConstants.trans("default_image")}
					description={ETVConstants.trans("default_image_explanation")}
					loading={this.state.uploading_default_img}
					bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.showWindow('',false)}/>}
				>
						{this.state.default_img_link || this.state.uploading_default_img?<span/>:
								<div style={{width:200,height:'auto'}}>
										<Dropzone
												onDrop={this.onDrop}
												disabled={false}
												accept={{ "image/jpeg": [] }}
												multiple={false}
												minSize={1024}
												maxSize={5242880}
												style={{width:'100%',height:'100%'}}>
										{({ getRootProps, getInputProps }) => (
											<div {...getRootProps({ className: "dropzone" })}>
													<input {...getInputProps()} />
													<p>{ETVConstants.trans("click_to_upload_files_max_5mb")}</p>
											</div>
										)}
										</Dropzone>
								</div>
						}
						{this.state.default_img_link?<Box component="img" sx={{width: '100%',height: 'auto',objectFit: 'cover',borderRadius: 2,}} src={ETVConstants.ON_PREMISE_VERSION?ETVConstants.makeContentURLRelative(this.state.default_img_link):this.state.default_img_link} />:<span/>}
						{this.state.default_img_link?<Button onClick={()=>this.deleteDefaultContents()} style={{marginTop:5}} size="small" variant="contained" color="secondary">{ETVConstants.trans("delete")}</Button>:<span/>}
	          	</ETVPopup>

          <ETVPopup
            open={this.state.window==='add_from_marketplace'}
            width="wide"
            onClose={()=>this.closeLibrary()}
			icon={<StorefrontIcon/>}
			title={ETVConstants.trans("add_from_marketplace")}
			bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.closeLibrary()}/>}
		  >
                {this.state.window==='add_from_marketplace'?<ContentLibrary visible={this.state.window==='add_from_marketplace'} children={this.props.children} marketplace={true} user_id={this.props.user_id} channel={this.props.channel} group_id={this.props.group_id} device_id={this.props.device_id} excluded_ids={excludedIDs} addedToChannelF={this.externalUpdatedF} />:<span/>}
          </ETVPopup>

          <ETVPopup
            open={this.state.window==='time_settings_div'}
			width="standard"
            onClose={()=>this.closeSettings()}
			icon={<ClockIcon/>}
			title={ETVConstants.trans("content_settings")}
			bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.closeSettings()}/>}
		  >
                {this.state.library_element?
                    <TimeDateSettings disabled={!this.state.can_edit} content_id={this.state.library_element.content_id} />
                  :<span/>
                }
          </ETVPopup>

          <ETVPopup
            open={this.state.window==='show_screens_div'}
            onClose={()=>{this.closeScreens()}}
			width="standard"
			icon={<AddScreenIcon/>}
			title={ETVConstants.trans("select_screens")}
			bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.closeScreens()}/>}
		  >
                {this.state.library_element?
                    <ScreenSelection channel={this.props.channel} children={this.props.children} user_id={this.props.user_id} content_id={this.state.library_element.content_id} library_element={this.state.library_element} updatedHook={this.externalUpdatedF} />
                    :
                    <span/>
                }
          </ETVPopup>
				</Box>
			);
	}
}

export default PlaylistChannel
